﻿import './MyProfile.scss';
import { Grid, Divider } from '@mui/material';
import { InfoLabel } from './PagesNavBar';

export default function Demographic({ ...props }) {
  function formatPhoneNumber(phoneNumberString) {
    // Remove all non-digit characters from the input string
    const cleaned = ('' + phoneNumberString).replace(/\D/g, '');

    // Check if the cleaned string has 10 digits
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      // Format the number as (XXX) XXX-XXXX
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }

    // If the input doesn't match the 10-digit pattern, return null or the original string
    return '';
  }

  return (
    <div style={{ margin: '1em 0', display: 'flex', flexDirection: 'column', gap: '1.5em' }}>
      {props.demographicInfo != null && (
        <>
          <div>
            <div className="sectionHeader">Name</div>
            <Divider sx={{ mb: 1 }} />
            <Grid container rowSpacing={2} columnSpacing={{ xs: 2, sm: 3, md: 4 }}>
              <InfoLabel label="Name:" data={[props.demographicInfo.fullName]} />
            </Grid>
          </div>

          <div>
            <div className="sectionHeader">Addresses</div>
            <Divider sx={{ mb: 1 }} />
            <Grid container rowSpacing={2} columnSpacing={{ xs: 2, sm: 3, md: 4 }}>
              <InfoLabel
                fullWidth
                label="Business Address:"
                data={[
                  props.demographicInfo.businessAddressLine1,
                  props.demographicInfo.businessAddressLine2,
                  props.demographicInfo.businessAddressLine3,
                ]}
              />
              <InfoLabel
                fullWidth
                label="Mailing Address:"
                data={[
                  props.demographicInfo.mailingAddressLine1,
                  props.demographicInfo.mailingAddressLine2,
                  props.demographicInfo.mailingAddressLine3,
                ]}
              />
              <InfoLabel
                fullWidth
                label="Residential Address:"
                data={[
                  props.demographicInfo.residenceAddressLine1,
                  props.demographicInfo.residenceAddressLine2,
                  props.demographicInfo.residenceAddressLine3,
                ]}
              />
            </Grid>
          </div>

          <div>
            <div className="sectionHeader">Contact Info</div>
            <Divider sx={{ mb: 1 }} />
            <Grid container rowSpacing={2} columnSpacing={{ xs: 2, sm: 3, md: 4 }}>
              <InfoLabel
                label="Phone:"
                data={[formatPhoneNumber(props.demographicInfo.phoneNumber)]}
              />
              <InfoLabel label="Business Email:" data={[props.demographicInfo.emailAddress]} />
              <InfoLabel
                label="National Producer Number:"
                data={[props.demographicInfo.nationalProducerNumber]}
              />
              {/*<InfoLabel label="Agency Name:" data={[props.demographicInfo.agencyName]} />
                        <InfoLabel label="Upline Name:" data={[props.demographicInfo.uplineName]} />*/}
              <InfoLabel label="Contract ID:" data={[props.demographicInfo.contractID]} />
              <InfoLabel label="Email:" data={[props.demographicInfo.emailAddress]} />
            </Grid>
          </div>
        </>
      )}
    </div>
  );
}
